import { trackEvent } from "./track";

export default function documentMailer() {
    const triggers = document.querySelectorAll(".email-link, .email-link-pdf");
    const modal = document.getElementById("email-doc-modal");
    if (!modal) return;

    triggers.forEach(trigger => {
        trigger.addEventListener("click", () => {
            const data = trigger.dataset;
            const title = data.bsTitle ?? "";
            const docUrl = data.bsDocument ?? "";
            const jobCode = data.jobCode ?? "";
            const lastUpdate = data.lastUpdate ?? "";
            const template = data.bsTemplate ?? "";

            const form = modal.querySelector("form");
            form.querySelector("[name='title']").value = title;
            form.querySelector("[name='document']").value = docUrl;
            form.querySelector("[name='jobCode']").value = jobCode;
            form.querySelector("[name='lastUpdate']").value = lastUpdate;
            form.querySelector("[name='template']").value = template;
            trackEvent({
                ModalDataNameEmailPDF: title
            });
        });
    });
}
